module.exports = __webpack_public_path__ + "static/media/2k_earth_daymap.eec7a2f8.jpg";